import styles from '../calendar.module.css'
import { useInlineSettings } from '../../../contexts/InlineSettingsContext'
import React from 'react'
import DatePicker from 'react-datepicker'
import { Box } from '@chakra-ui/core'
import { useDatePickerLocale } from 'hooks/useDatePickerLocale'
import 'react-datepicker/dist/react-datepicker.css'

interface DatePickerComponentProps {
  isOpen: boolean
  onClose: () => void
  selectedDate: Date
  handleDateChange: (date: Date | null) => void
  minDate: Date
  useCustomTranslations?: boolean
}

export const StartDatePickerComponent: React.FC<DatePickerComponentProps> = ({
  isOpen,
  onClose,
  selectedDate,
  handleDateChange,
  minDate,
  useCustomTranslations = true,
}) => {
  const inlineSettings = useInlineSettings()
  const datePickerLocale = useDatePickerLocale(useCustomTranslations)

  return isOpen ? (
    <Box
      className={styles.wrapper}
      pos={inlineSettings ? 'relative' : 'absolute'}
      zIndex={inlineSettings ? 1 : 9999}
      top={inlineSettings ? undefined : '80px'}
      w={inlineSettings ? '100%' : '65%'}
      left={inlineSettings ? undefined : '50%'}
      transform={inlineSettings ? undefined : 'translateX(-50%)'}
    >
      <DatePicker
        calendarClassName={styles.calendar}
        open
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="dd/MM/yy HH:mm"
        locale={datePickerLocale}
        minDate={minDate}
        showMonthDropdown
        showYearDropdown
        inline
        onClickOutside={onClose}
      />
    </Box>
  ) : null
}
